module.exports = "/assets/dadcc8e40452fc0cc2de1dc0399b2bf3.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/A9.png
// module id = 1187
// module chunks = 0